import React from 'react'
import ReactDOM from 'react-dom/client'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { I18nextProvider } from 'react-i18next'
import { LanguageProvider } from './i18n/LanguageProvider'
import { AppRouter } from './router'
import i18n from './i18n/config'
import theme from './theme/muiTheme'
import './styles/index.css'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <I18nextProvider i18n={i18n}>
        <LanguageProvider>
          <AppRouter />
        </LanguageProvider>
      </I18nextProvider>
    </ThemeProvider>
  </React.StrictMode>,
)
